<div class="bg-animated-wrapper">
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>
  <div class="blob blob-3"></div>
  <div class="blob blob-4"></div>
</div>

<div class="relative z-10">
  <router-outlet></router-outlet>
</div>

<app-confirm-dialog></app-confirm-dialog>